export default {
	SESSION_PREVIEW: 'session-preview',
	EXPLORE_LESSONS: 'explore-lessons',
	LESSON_BUILDER: 'lesson-builder',
	LAUNCH_TOUR: 'launch-tour',
}
